import http from "../../../http-common.js";

export default {
  async getUsers(context) {
    try {
      const response = await http.get("/subadmin");

      if (response.status == 200) {
        const responseData = response.data;
        context.commit("setUsers", responseData);
      } else {
        const error = new Error("Something went wrong!");
        throw error;
      }
    } catch (error) {
      const errorMessage = {
        status: error.response.data.success,
        message: new Error(error.response.data.message || "Something failed!"),
      };
      throw errorMessage;
    }
  },
  async createUser(context, data) {
    let userData;
    try {
      const response = await http.post("/subadmin", data);
      if (response.status == 201) {
        userData = {
          username: data.username,
          name: data.name,
          email: data.email,
          phone: data.phone,
          status: 1,
          isLoggedIn: 0,
          is_deleted: 0,
          balance: data.openingBalance || 0,
          payInLimit: data.payInLimit || 0,
          payInCommission: data.payInCommissionPercentage || 0,
          payOutCommission: data.payOutCommissionPercentage || 0,
        };
      } else {
        const error = new Error("Something went wrong!");
        throw error;
      }
    } catch (error) {
      const errorMessage = new Error(
        error.response?.data?.message || "Something failed!"
      );
      throw errorMessage;
    }

    context.commit("addUser", userData);
  },
  async updateUser(context, data) {
    const username = data.username;
    const status = data.status;
    const payload = { ...data };
    delete payload.username;
    delete payload.status;
    try {
      const response = await http.put(`/subadmin/${username}`, payload);
      if (response.status != 200) {
        throw new Error("Something went wrong!");
      }
    } catch (error) {
      const errorMessage = new Error(
        error.response?.data?.message || "Something failed!"
      );
      throw errorMessage;
    }

    // Merge updated fields onto existing user — don't lose unrelated fields
    const updates = {
      username,
      status,
      name: data.name,
      email: data.email,
      phone: data.phone,
      payInLimit: data.payInLimit,
      payInCommission: data.payInCommissionPercentage,
      payOutCommission: data.payOutCommissionPercentage,
    };
    // Only mirror the manual-approve flag locally when it was actually
    // submitted (UserForm only includes it when the toggle moved). Avoids
    // wiping the existing value to undefined on every other field's edit.
    if (Object.prototype.hasOwnProperty.call(data, "can_approve_payin_manually")) {
      updates.can_approve_payin_manually = data.can_approve_payin_manually;
    }
    // Routing-exclusivity flags — same conditional-mirror rule: UserForm
    // only sends them when the toggle actually moved. Omitting them here
    // was the bug where the branch edit persisted server-side but the list
    // kept showing the old EXCLUSIVE/OPEN value until a full getUsers
    // refetch (refresh / leave-and-return).
    if (Object.prototype.hasOwnProperty.call(data, "branch_serves_default_payin")) {
      updates.branch_serves_default_payin = data.branch_serves_default_payin;
    }
    if (Object.prototype.hasOwnProperty.call(data, "branch_serves_default_payout")) {
      updates.branch_serves_default_payout = data.branch_serves_default_payout;
    }
    context.commit("updateUser", updates);
  },
  async deleteUser(context, user) {
    const username = user.username;

    try {
      const response = await http.delete(`/subadmin/${username}`);
      if (response.status == 200) {
        context.commit("deleteUser", username);
      } else {
        const error = new Error("Something went wrong!");
        throw error;
      }
    } catch (error) {
      const errorMessage = new Error(
        error.response.data.message || "Something failed!"
      );
      throw errorMessage;
    }
  },
  async changeUserStatus(context, payload) {
    const { username, status } = payload;

    try {
      const response = await http.post(`/subadmin/${username}/status`, { status });
      if (response.status == 200) {
        context.commit("updateUserStatus", { username, status });
      } else {
        const error = new Error("Something went wrong!");
        throw error;
      }
    } catch (error) {
      const errorMessage = new Error(
        error.response.data.message || "Something failed!"
      );
      throw errorMessage;
    }
  },
};
